import React, { useState } from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  RestPageListBean,
  SalesAnalysisInquiryCriteriaBean,
  YearlyStasticsSalesAnalysisRequest,
} from "../ds/ds.js";
import { PlayIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyString, toDownloadReportAddress } from "../gui_components/Util.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
class YearlySalesAnalysis extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Yearly Sales Analysis Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new SalesAnalysisInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableFields: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
  }
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    return success;
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  validate = (criteria) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (isEmptyString(criteria.companyCode)) {
      let errMsg = "companyCode is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(criteria.startYear)) {
      let errMsg = "year 1 is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(criteria.endYear)) {
      let errMsg = "year 2 is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let isValid = false;
    isValid = this.validate(criteria);
    if (isValid) {
      this.generateYearlySalesAnalysisReport();
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  generateYearlySalesAnalysisReport = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = 2;
    let listRequest = new YearlyStasticsSalesAnalysisRequest();
    listRequest.criteria = criteria;
    listRequest.input = reportBean;
    if (
      SecurityAccessManager.YearlySalesAnalysisInquiryExcelReport_IsAccessible()
    ) {
      ReportService.generateYearlyStasticsSalesAnalysisReport(
        listRequest,
        this.generateYearlySalesAnalysisPageExcelResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(3);
    }
  };

   generateYearlySalesAnalysisPageExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesAnalysisInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({ criteria: criteria });
  };
  resetInquiry = () => {
    let criteria = new SalesAnalysisInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  render() {
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          {...this.state}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = (e) => {
    if (e.detail === 1) {
      handleButton();
      props.loadPage(1);
    }
  };
  // const yearRef = useRef(null);
  // useEffect(() => {
  //   if (yearRef.current) {
  //     yearRef.current.focus();
  //   }
  // }, []);
  let criteria = props.criteria;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Year1</FormLabel>
        </Col>
        <Col sm="2">
          <NumberFormatInputbox
            // ref={yearRef}
            name="startYear"
            placeholder="year1"
            onChange={onChange}
            value={criteria.startYear}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Year2</FormLabel>
        </Col>
        <Col sm="2">
          <NumberFormatInputbox
            onChange={onChange}
            name="endYear"
            placeholder="year2"
            value={criteria.endYear}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          {props.is3PL ? (
            <FormLabel>Exclude Sample Item</FormLabel>
          ) : (
            <FormLabel>Exclude SampleFabric</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputCheckbox
            onChange={onChange}
            name="excludeSampleItemFlag"
            checked={criteria.excludeSampleItemFlag}
          />
        </Col>
        <Col sm="2">
          <Button
            className="header_buttons"
            size="sm"
            onClick={(e) => loadPage(e)}
          >
            {" "}
            <PlayIcon />
            {""}EXEC{" "}
          </Button>
        </Col>
      </Row>
    </div>
  );
}

function YearlySalesAnalysisInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <YearlySalesAnalysis {...props} name="" /> <br />
    </div>
  );
}

export default YearlySalesAnalysisInquiry;
